import styled from 'styled-components';
import { focusRing } from '@/app/components/search/styles/mixins.ts';

export const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.kallisto.space.space150};
`;

export const GroupTitle = styled.div`
  ${({ theme }) => theme.kallisto.mixins.font('Title5')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
`;

export const ChipList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.kallisto.space.space100};
`;

export const ChipsWithToggle = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.kallisto.space.space100};
`;

export const ShowMoreButton = styled.button<{ $expanded?: boolean }>`
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.kallisto.space.space50};
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  text-align: left;
  ${({ theme }) => theme.kallisto.mixins.font('Body')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};

  .arrow {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    transform: rotate(${({ $expanded }) => ($expanded ? '180deg' : '0deg')});
    transition: transform 0.3s ease;
  }

  &:focus-visible {
    ${focusRing};
  }
`;

export const ShowMoreLabel = styled.span`
  text-decoration: underline;
`;
